import { PlaylistItemDTO } from "../../lib/types";
import { SplitContentNode } from "@/pages/contentSplit/splitContent/splitContentTypes";
import { parseViewportSize } from "@/components/canvas/utils/viewportUtils";
import { SplitContentLayout } from "@/pages/contentSplit/splitContent/SplitContentLayout";

type Props = {
  item: PlaylistItemDTO;
  isFullScreen?: boolean;
};

export const DSPlayerSplit: React.FC<Props> = ({ item }) => {
  const layout = JSON.parse(item.splitLayoutConfig || "{}") as SplitContentNode;

  if (layout && item.splitViewportSize) {
    const { width, height } = parseViewportSize(item.splitViewportSize);
    return (
      <div style={{ width, height, overflow: "hidden" }} data-testid="ds-split-content-layout">
        <SplitContentLayout
          layout={layout}
          layoutWidth={width}
          layoutHeight={height}
          onDragging={() => {}}
          renderExtraContentPerNode={() => null}
          mode="preview"
        />
      </div>
    );
  }

  return null;
};
